"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const print = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-print` : '') + (description ? ` desc-print` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-print"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-print"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.25 0C18.49 0 19.5 1.009 19.5 2.25V6H21.75C22.99 6 24 7.009 24 8.25V15.75C24 16.99 22.99 18 21.75 18H19.5V23.25C19.5 23.664 19.164 24 18.75 24H5.25C4.836 24 4.5 23.664 4.5 23.25V18H2.25C1.009 18 0 16.99 0 15.75V8.25C0 7.009 1.009 6 2.25 6H4.5V2.25C4.5 1.009 5.509 0 6.75 0H17.25ZM18 13.5H6V22.5H18V13.5ZM13.5 18C13.914 18 14.25 18.336 14.25 18.75C14.25 19.164 13.914 19.5 13.5 19.5H8.25C7.836 19.5 7.5 19.164 7.5 18.75C7.5 18.336 7.836 18 8.25 18H13.5ZM21.75 7.5H2.25C1.836 7.5 1.5 7.836 1.5 8.25V15.75C1.5 16.163 1.836 16.5 2.25 16.5H4.5V12.75C4.5 12.336 4.836 12 5.25 12H18.75C19.164 12 19.5 12.336 19.5 12.75V16.5H21.75C22.163 16.5 22.5 16.163 22.5 15.75V8.25C22.5 7.836 22.163 7.5 21.75 7.5ZM15.75 15C16.164 15 16.5 15.336 16.5 15.75C16.5 16.164 16.164 16.5 15.75 16.5H8.25C7.836 16.5 7.5 16.164 7.5 15.75C7.5 15.336 7.836 15 8.25 15H15.75ZM5.25 9C5.664 9 6 9.336 6 9.75C6 10.164 5.664 10.5 5.25 10.5H3.75C3.336 10.5 3 10.164 3 9.75C3 9.336 3.336 9 3.75 9H5.25ZM17.25 1.5H6.75C6.336 1.5 6 1.836 6 2.25V6H18V2.25C18 1.836 17.663 1.5 17.25 1.5Z",
    fill: "inherit"
  }));
};
var _default = exports.default = print;